const module = { name: 'fd-location/alertBox', exports: {} }; const exports = module.exports;



let form


let loading = false


const Selectors = {
    ALERT_BOX: '#alertBox',
    FD_LOADING: '.fd-loading',
    FORM: '#locationForm',
    LABEL: '#alertBoxLabel',
}


const Styles = {
    ERROR: 'alert-box--error',
    FD_LOADING: 'fd-loading',
}
function showError(msg) {
    if (!form) {
        return;
    }
    form.classList.add(Styles.ERROR);
    form.querySelector(Selectors.LABEL).innerHTML = msg;
}
function hideError() {
    if (!form) {
        return;
    }
    form.classList.remove(Styles.ERROR);
}
function setBusy(state) {
    loading = state;
    if (!form) {
        return;
    }
    const alertBox = form.querySelector(Selectors.ALERT_BOX);
    let spinner = form.querySelector(Selectors.FD_LOADING);
    if (loading && !spinner) {
        spinner = document.createElement('span');
        spinner.classList.add(Styles.FD_LOADING);
        alertBox.prepend(spinner);
    }
    else if (!loading && spinner) {
        spinner.remove();
    }
}
function isBusy() {
    return loading;
}
function init() {
    form = document.querySelector(Selectors.FORM);
}
module.exports = {
    hideError,
    showError,
    setBusy,
    isBusy,
    init
};
export default module.exports;